<template>
  <div class="">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-top">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/icon-books.svg" width="50" alt="Minds" class="">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">

        <div class="container align-items-center mobileWrap">
          <h2 class="animation-top animation-delay-02"><strong> {{ (speakUp.book_name || '').toUpperCase() }}</strong> {{ (speakUp.lesson_name || '').toUpperCase() }} </h2>
          <div class="margin-left-10 margin-right-10 container aling-items-end animation-top animation-delay-04 mobileAdjust">
            <button style="color: rgb(196, 0, 60);" class="btn btn-sm btn-rounded gradient-yellow btn-padding mobileAdjust" @click="$router.go(-1)">Voltar</button>
          </div>
        </div>

        <hr class="header-text-hr animation-top animation-delay-02">
        <div class="container mobileWrap">
          <div style="width: 150px" class="title--mark-bt title--mark-bk gradient-yellow color-red margin-right-10 float-left animation-top animation-delay-04 mobileAdjust">
            {{ date }}
          </div>
          <div class="title--mark-bt title--mark-bk gradient-yellow color-red margin-right-10 float-left animation-top animation-delay-04 mobileAdjust">
            {{ status.toUpperCase() }}
          </div>
          <div class="title--mark-bt title--mark-bk color-red margin-right-10 float-left animation-top animation-delay-04 mobileAdjust" style="background-color: #fff;">
            Score: {{ speakUp.score }}
          </div>
        </div>

      </div>
    </div>

    <div class="box-content shadow-box box-content-border relative hidden gview">
      <div class="unit-challenge container">
        <div class="unit-challenge__video flex-grow-1 flex-basis-400 container align-center animation-top relative">
          <img src="@/assets/img/exercicies/words-attack/intro.png" class="unit-challenge__video--image" width="100%" alt="">
        </div>
        <div class="unit-challenge__questions flex-grow-1 flex-basis-400">
          <exercicies :data="subTopics" />
        </div>
      </div>

      <!-- <modal ref="modal" :show="reseted"> -->
      <modal ref="modal" :show="finished" bgcolor="rgba(243, 243, 243, .95)" :closebtn="false">
        <modalSpeakUp :speakup="speakUp" :close="emitClose"/>
      </modal>
    </div>
    <div class="box-content container wrap" v-if="speakUp.finished">
      <div class="animation-bottom container--unit col-12 col-xl-2 col-lg-3 col-md-4 col-sm-12" v-for="sb in finishedSubTopics">
        <div class="container--unit__box">
          <div class="container--unit__ball container" :style="{background: 'linear-gradient(-45deg,' + sb.cor1 + ' 0% , ' + sb.cor2 + ') 100% '}">
            <span class="span-unit">{{ sb.lesson.split(' ')[0] }}</span>
            <h3>{{ sb.lesson.split(' ')[1] }}</h3>
          </div>

          <div class="container--unit__title margin-top-10 margin-bottom-10">
            <p><strong>Score:</strong> {{ sb.points.toFixed(2) }}</p>
          </div>
          <div class="container--unit__btn container align-items-center justify-content-center">
            <button type="button" class="btn btn-rounded color-dark btn-sm gradient-finished" name="button" @click="viewSubTopic(sb)">VIEW</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { cloneDeep } from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import exercicies from '@/components/game/exerciciesVertical'
import modal from '@/components/modal'
import modalBus from '@/components/modal/modalBus'
import modalSpeakUp from '@/components/speakup/modalSpeakUp'

export default {
  computed: {
    ...mapGetters({
      speakUp: 'speakup/getSpeakUp',
      hasSpeakUp: 'speakup/hasSpeakUp',
      _subTopics: 'speakup/getSubTopics',
      finished: 'speakup/isFinished',
    }),
    subTopics () {
      return cloneDeep(this._subTopics).sort((a, b) => parseInt(a.order) - parseInt(b.order))
    },
    finishedSubTopics () {
      if (!this.speakUp.finished)
        return []

      return cloneDeep(this._subTopics)
              .sort((a, b) => a.lesson_order - b.lesson_order)
              .map((i, index) => {
                switch (index % 3) {
                  case 0:
                    i.cor1 = '#E12F67'
                    i.cor2 = '#8D00FF'
                    break
                  case 1:
                    i.cor1 = '#00F0FF'
                    i.cor2 = '#6FBE15'
                    break
                  case 2:
                    i.cor1 = '#FF9C00'
                    i.cor2 = '#FF0000'
                    break
                  default:
                    break
                }

                return i
              })
    },
    status () {
      switch (this.speakUp.status) {
        case 'A':
          return 'Waiting'
        case 'I':
          return 'Initiated'
        case 'F':
          return 'Finished'
        default:
          return ''
      }
    },
    date () {
      if (!this.speakUp || !this.speakUp.date)
        return ''

      return new Date(this.speakUp.date.split('.').shift()).toLocaleString()
    }
  },
  components: {
    exercicies,
    modal,
    modalSpeakUp
  },
  methods: {
    ...mapMutations({
      setShowLoader: 'setShowLoader',
      setFinished: 'speakup/setFinished',
    }),
    ...mapActions({
      getSpeakUp: 'speakup/getSpeakUp',
      getSubTopics: 'speakup/getSubTopics',
      setInterval: 'speakup/setInterval',
      clearInterval: 'speakup/clearInterval'
    }),
    viewSubTopic (subTopic) {
      this.$router.push({
        name: `${subTopic.type}-speakup`,
        params: {
          ...this.$route.params,
          subtopic_id: subTopic._id
        }
      })
    },
    closeModal () {
      this.setFinished(false)
      this.$router.push({ name: 'home' })
    },
    emitClose () {
      this.$refs['modal'].close()
    },
  },
  async mounted () {
    modalBus.$on('close', this.closeModal)

    try {
      this.setShowLoader(true)

      await this.getSpeakUp(this.$route.params.class_id)

      if (!this.hasSpeakUp) {
        this.setShowLoader(false)
        this.$router.replace('/speakup')
        return
      }

      if (this.speakUp.status !== 'F')
        this.setInterval(this.$route.params.class_id)

      await this.getSubTopics(this.$route.params.class_id)
      this.setShowLoader(false)
    } catch (error) {
      console.log(error)
      this.setShowLoader(false)
      this.$router.replace('/speakup')
    }
  },
  beforeDestroy () {
    modalBus.$off('close', this.closeModal)
    this.clearInterval()
  }
}
</script>

<style lang="scss">
@import './src/assets/css/components/_unitChallenge';

.mobileWrap {
  @media (max-width: 440px){
    flex-wrap: wrap;
    justify-content: center;
  }
}

.mobileAdjust {
  @media (max-width: 440px){
    width: 100%;
    justify-content: center;
    margin: 5px;
  }
}

.life-box {
  width: 75px;
    @media (max-width: 440px){
      width: 100%;
      justify-content: center;
      margin: 5px;
    }
  .life-item {
    margin-left: 5px;
      &:first-child {
        margin-left: 10px;
      }
  }
}

.used {
  filter: grayscale(.75);
}


.btn-transition {
  &-enter-active,
  &-leave-active {
    transition: opacity .2s;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}

.container--unit {
    padding: 7px 13px;
    box-sizing: border-box;
    margin-top: 25px;
    position: relative;
    .container--unit__box {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08), 0 6px 7px 0 rgba(0,0,0,0.04);
        border-radius: 20px;
        box-sizing: border-box;
        border: 2px solid rgb(82, 82, 82);
        text-align: center;
        transition: 0.3s;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
            transform: scale(1.06);
            background: #dfdfdf;
            box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);
        }
        .container--unit__title {
            font-size: 14px;
            text-align: center;
            color: #717171;
        }
        .container--unit__btn {
            margin: 5px 0px 10px 0px;
        }
        .container--unit__ball {
            width: 105px;
            height: 55px;
            margin-top: -20px;
            border-radius: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            text-align: center;
            // margin: 0 auto;
            // flex-direction: column;
            // position: relative;
            span {
                font-size: 15px;
                font-weight: 300
                // position: absolute;
                // top: 8px;
                // left: 0;
                // width: 100%;
                // text-align: center;
            }
            h3 {
                font-size: 40px;
                margin-left: 5px;
                font-weight: 400;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/speakup/speakup.vue